import GlobalMixin from '@/app/shared/mixins/global';
import MapPermissionsMixin from '@/components/maps/mixins/MapPermissionsMixin';


export default {
    mixins: [
        GlobalMixin,
        MapPermissionsMixin,
    ],
    props: {
        moduleCode: {
            type: String,
            required: true,
        },
        toolId: {
            type: String,
            default: null,
        },
        showButtonOnActionMap: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            pageID: null
        }
    },
    computed: {
        acl(){
            let id = this.pageID;
            // return id ? this.$store.getters[`${this.moduleCode}/getAcl`](id) : {};
            return id ? this.$store.getters.getAcl(this.moduleCode, id) : {};
        },
        url(){
            let id = this.pageID;
            // return id ? this.$store.getters[`${this.moduleCode}/getUrl`](id) : {};
            return id ? this.$store.getters.getUrl(this.moduleCode, id) : {};
        },
        enableTool() {
            return this.checkTool(this.pageID);
        },
    },
    beforeMount() {
        if(this.toolId){
            this.pageID = this.toolId;
        }
    }
}